export type KnownCookies = "cvBase" | "permissionLevel" | "3PAdsOptOut";
export const getCookie = (cookieName: KnownCookies): string | undefined => {
  // document.cookie is a series of cookies of the form "foo=value; bar=something"
  const cookieString = document.cookie
    .split("; ")
    .find(cookie => cookie.startsWith(`${cookieName}=`));
  if (cookieString === undefined) {
    return undefined;
  }
  return cookieString.split("=")[1];
};
